<template>
  <div id="main-client">
    <el-row>
      <el-button @click="showUpdateDialog(null)">添加客户端</el-button>
    </el-row>
    <el-row>
      <el-table
        :data="clients"
        style="width: 90%">
        <el-table-column
          width="150"
          prop="clientId"
          label="编号">
        </el-table-column>
        <el-table-column
          width="150"
          prop="scope"
          label="范围">
        </el-table-column>
        <el-table-column
          width="350"
          prop="clientSecret"
          label="密钥">
        </el-table-column>
        <el-table-column
          prop="authorizedGrantTypes"
          label="授权类型">
        </el-table-column>
        <el-table-column
          width="250"
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-button type="primary" size="mini" @click="loadClientRoles(scope.row.clientId)">角色</el-button>
              </el-col>
              <el-col :span="6">
                <el-popconfirm
                  @onConfirm="deletClient(scope.row.id)"
                  title="确定删除当前客户端吗?">
                  <el-button type="danger" size="mini" slot="reference">删除</el-button>
                </el-popconfirm>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" size="mini" @click="showUpdateDialog(scope.row)">修改</el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog
      title="更新客户端"
      :visible.sync="addClientDialog"
      width="30%">
      
      <el-row type="flex" justify="center">
        <el-col :span="21">
            <el-input v-model="currentClient.clientId" 
            :clearable="true" :disabled="currentClient.clientIdEditAble"
            placeholder="客户端编号"></el-input>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
          <el-col :span="21">
              <el-input v-model="currentClient.scope" :clearable="true" placeholder="权限范围"></el-input>
          </el-col>
      </el-row>
      <el-row type="flex" justify="center">
          <el-col :span="21">
              <el-input v-model="currentClient.authorizedGrantTypes" :clearable="true" placeholder="授权类型"></el-input>
          </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addClientDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveClient">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="客户端角色"
      :visible.sync="clientRoleDialog"
      width="30%">
      <el-tree
          :data="clientRoleData.roles"
          show-checkbox
          node-key="roleId"
          :props= "clientRoleData.permissionTreeProps"
            @check-change="handleCheckChange"
          :default-checked-keys="clientRoleData.clientRoleIds">
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clientRoleDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeClientRole">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { queryClients,updateClientRoles,updateClient } from "@/api/client.js"
import { getClientRoles } from "@/api/role.js"

export default {
  name: 'Client',
  data() {
    return {
      clients: [],
      currentClient: {clientId: null, roleIds: ""},
      addClientDialog: false,
      clientRoleDialog: false,
      clientRoleData: {
        roles: [],
        clientRoleIds: [],
        clientRoleIdSet: null,
        permissionTreeProps: {label: 'roleChName'}
      }
    }
  },
  watch: {
    
  },
  created() {
  },
  mounted() {
    queryClients().then(data=>{
      this.clients = data.data.records
    })
  },
  destroyed() {
    
  },
  methods: {
    showUpdateDialog(row){
      if(row){
        this.currentClient = row
        this.currentClient.clientIdEditAble=true
      }else{
        this.currentClient.clientIdEditAble=false
      }
      this.addClientDialog = true
    },
    queryClient(){
      queryClients().then(data=>{
          this.clients = data.data.records
        })
    },
    saveClient(){
       updateClient(this.currentClient).then(()=>{
        this.addClientDialog = false
        this.queryClient()
        Object.assign(this.$data.currentClient , this.$options.data().currentClient );
       })
    },
    deletClient(clientId){
      // removeClient({"userId": clientId}).then(()=>{
      //   this.queryUser()
      // })
    },
    loadClientRoles(clientId){
      this.currentClient.clientId = clientId;
      this.clientRoleDialog = true;
      getClientRoles(clientId).then(data=>{
        this.clientRoleData.clientRoleIdSet = new Set()
        this.clientRoleData.roles = data.data
        this.clientRoleData.roles.forEach(rp=>{
            if(clientId!=rp.clientId){
                return
            }
            this.clientRoleData.clientRoleIdSet.add(rp.roleId)
        })
        this.clientRoleData.clientRoleIds = [...this.clientRoleData.clientRoleIdSet]
      })
    },
    handleCheckChange(data, checked) {
        if(checked){
            this.clientRoleData.clientRoleIdSet.add(data.roleId)
        }else{
            this.clientRoleData.clientRoleIdSet.delete(data.roleId)
        }
    },
    changeClientRole(){
      let roleIds = [...this.clientRoleData.clientRoleIdSet]
      let data = {clientId: this.currentClient.clientId, roleIds: roleIds.join(",")}
      updateClientRoles(data).then(()=>{
        this.clientRoleDialog = false
      })
    },
  }
}
</script>

<style lang="scss">
  #main-client{
    .el-dialog .el-row{
      margin-bottom: 15px;
    }
  }
</style>
